import { useEffect } from "react";
import { HeroSectionTypesProps } from "../../types/HeroSectionPropsType";
import useWindowSize from "../../hooks/useWindowSize";
import MainHeroSection from "./HeroSections/MainHeroSection";
import PosterVideo from '../../assets/images/posters/video-poster.jpg';
import MobHeroSectionTwo from "./HeroSections/MobHeroSectionTwo";

const HeroSection = ({
  image,
  title,
  subtitle,
  videos = [
    
  ],
}: HeroSectionTypesProps) => {

  const width = useWindowSize();

  // useEffect(() => {
  //   console.log(width)
  // }, [width])

  return (
    <>
      {width > 900 ?
       <MainHeroSection 
        image={image}
        title={title}
        subtitle={subtitle}
        videos={[
          require("../../assets/videos/trees-1.mp4"),
          require("../../assets/videos/sea.mp4"),
          require("../../assets/videos/clouds.mp4"),
          require("../../assets/videos/woman.mp4"),
        ]}
        posterImage={PosterVideo}
       />:
      <MobHeroSectionTwo 
        image={image}
        title={title}
        subtitle={subtitle}
      />
      }
    </>
  );
};

export default HeroSection;
